export default async function ({ store, redirect, app }) {
    if (!store.state.checkout.success) {
        redirect('/');
    }
    store.commit('checkout/set_success', false);
}
